import { EditOutlined, PrinterOutlined, QrcodeOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Descriptions,
  Divider,
  Dropdown,
  Empty,
  Image,
  Menu,
  Modal,
  Popconfirm,
  Row,
  Space,
  Typography,
  message,
} from 'antd';
import axios from 'axios';
import moment from 'moment';
import { useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import imgMore from '../../../assets/img/common/fi_more.svg';
import { MdDateRange } from 'react-icons/md';
import { IoWarningOutline } from 'react-icons/io5';

import { BsBox2 } from 'react-icons/bs';
import { GrMapLocation } from 'react-icons/gr';
import { IoDocumentTextOutline } from 'react-icons/io5';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { CiLocationOn } from 'react-icons/ci';

import DeliveryStatusBadge from '../components/DeliveryStatusBadge';
import ProductTable from './ProductTable';
import { getOrderStatus } from '../../../utils';
import { getDateTime } from '../../../utils/format';
import { DeliverySlip } from './DeliverySlip';
import './style.less';

const { Text, Title } = Typography;

const STATUS_ENUM = {
  created: 'Захиалга үүссэн',
  reserved: 'Захиалга хүлээлгэнд байна',
  partialcomplete: 'Захиалга бүрдэж байна',
  completed: 'Захиалга бүрдсэн',
  sorter: 'Захиалга бэлтгэл',
  dispatcher: 'Хүргэхэд бэлэн',
  driverAssigned: 'Жолоочид хуваарилсан',
  delivery: 'Хүргэлтэд гарсан',
  delivered: 'Хүргэгдсэн',
  canceled: 'Цуцлагдсан',
};

/** Хоосон утгыг "-" болгож харуулна */
const val = (value) => (value === null || value === undefined || value === '' ? '-' : value);

/** Descriptions-ийн ерөнхий тохиргоо: label дээр, value доор, зай багатай */
const descriptionProps = {
  size: 'small',
  colon: false,
  layout: 'vertical',
  column: { xs: 1, sm: 2 },
  labelStyle: { paddingBottom: 0 },
  contentStyle: { paddingBottom: 8 },
};

const Detail = ({ detail = {}, resultMeta = {} }) => {
  const [visible, setVisible] = useState(false);
  const slipRef = useRef();
  const [isSlipVisible, setIsSlipVisible] = useState(false);
  const rejectedText = 'Захиалга цуцлахдаа итгэлтэй байна уу?';

  const deliverStatus = ['dispatcher', 'driverassigned', 'delivery'];
  const whStatus = ['partialcomplete', 'placed', 'picked', 'sorter', 'whpicker', 'completed'];

  const handlePrintDeliverySlip = ({ key }) => {
    setIsSlipVisible(true);
  };
  const getReturnProducts = () => {
    let returnProducts = [];
    detail?.allOrders?.forEach((item) => {
      let product = {
        baseSku: item.baseSku,
        productSKU: item.productSKU,
        productTitle: item.productTitle,
        productImage: item.productImage,
        productPrice: item.productPrice,
        productType: item.productType,
        productVolume: item.totalVolume / item.totalUnit,
        productTotalUnit: item.totalUnit,
        productTotalWeight: item.totalUnitReturn * (item.totalWeight / item.totalUnit),
      };
      if (item.expiryDate) product.productExpiryDate = item.expiryDate;
      returnProducts.push(product);
    });

    return returnProducts;
  };

  let reqData = {
    returnProducts: getReturnProducts(),
    returnPlace: detail?.pickupAddressCode,
    returnPhone: detail?.customerPhone,
    returnEmail: detail?.customerEmail,
    returnName: detail?.customerName,
    returnCode: detail?.code,
    returnDetail: detail?.dropoffDetail,
    returnPositionCode: detail?.dropoffAddressCode,
    dropoffAddressCode: detail?.pickupAddressCode,
    pickupType: 'delivery-item',
    pickupDate: moment().format(),
    pickupTime: moment().format(),
    pickupAddress: detail?.dropoffAddressArray,
    dropoffDate: moment().add(1, 'hours'),
    dropoffTime: moment().add(1, 'hours'),
    notes: 'customerWish',
    orderDescription: 'Цуцлах үеийн буцаалт',
  };

  const onReject = async () => {
    const body = {
      orderId: detail?.code,
      orderStatus: 'canceled',
    };
    const forceCancelBody = {
      code: detail?.code,
    };
    try {
      let isSuccess = false;
      if (deliverStatus.includes(detail?.orderStatus)) {
        const req1 = axios.post('/api/v1/request/create-return-request', reqData);
        const req2 = axios.post('/api/v1/request/forceCancel', forceCancelBody);
        const [res1, res2] = await Promise.all([req1, req2]);
        if (res1.data.statusCode === 200 && res2.data.statusCode === 200) isSuccess = true;
      } else if (whStatus.includes(detail?.orderStatus)) {
        const { data } = await axios.post('/api/v1/request/forceCancel', forceCancelBody);
        if (data.statusCode === 200) isSuccess = true;
      } else if (detail?.orderStatus === 'created') {
        const { data } = await axios.post('/api/v1/request/statusChange', body);
        if (data.statusCode === 200) isSuccess = true;
      }

      if (isSuccess) {
        message.success('Захиалга амжилттай цуцлагдлаа');
        window.location.reload();
      }
    } catch (err) {
      console.error('Захиалга цуцлах: ', err);
    }

    // }
  };
  const onPrint = useReactToPrint({
    content: () => slipRef.current,
  });

  const closeDeliverySlip = () => setIsSlipVisible(false);
  const more = (
    <Menu
      className="more_menu"
      items={[
        {
          key: '1',
          label: 'Засах',
          icon: <EditOutlined />,
        },
        {
          key: '2',
          label: 'QR хэвлэх',
          icon: <QrcodeOutlined />,
        },
        {
          key: '3',
          label: 'Хэвлэх',
          icon: <PrinterOutlined />,
        },
      ]}
      onClick={handlePrintDeliverySlip}
    />
  );

  // Төлвийн нэр: STATUS_ENUM-ыг эхэлж, байхгүй бол meta-гийн enumDictionary-г хэрэглэнэ
  const statusText =
    STATUS_ENUM[detail?.orderStatus] ??
    getOrderStatus(resultMeta?.orderStatus?.enumDictionary, detail?.orderStatus);
  const dropoffAddress = detail?.dropoffAddressArray ?? [];

  /**
   * ТАТАН АВАХ (pickup) байршлын хаяг.
   *
   * «Хаанаас авах» карт нь `dropoff*` (ХҮРГЭХ) талбаруудыг уншдаг байсан тул
   * 1-р шатанд сонгосон салбар («CL1») дэлгэрэнгүйд хоосон «-» харагддаг байв.
   * Татан авах байршил нь `pickupAddressCode` + `pickupAddressArray` +
   * `pickupDetail`-д хадгалагддаг.
   */
  const pickupAddressText = [
    ...(detail?.pickupAddressArray ?? []).map((unit) => unit?.name).filter(Boolean),
    detail?.pickupDetail,
  ]
    .filter(Boolean)
    .join(', ');

  const attentionNotes = [
    ...(detail?.notes?.length > 0 ? detail.notes : []),
    ...(detail?.allOrders?.some((item) => item?.isFragile) ? ['Бараа эвдрэх аюултай'] : []),
  ];
  const dropoffTime =
    detail?.dropoffTime?.length > 1
      ? `${moment(detail.dropoffTime[0]).format('HH:mm')} - ${moment(detail.dropoffTime[1]).format(
          'HH:mm'
        )}`
      : null;

  const renderProductGroups = (groups = [], title, withPhone = false) =>
    groups
      .filter((group) => group?.products?.length > 0)
      .map((group) => (
        <Card
          key={group.code}
          title={
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              <BsBox2 style={{ display: 'block', fontSize: '1em' }} />
              {title}
            </span>
          }
          size="middle"
          styles={{ body: { padding: 0 } }}
        >
          <Descriptions
            {...descriptionProps}
            column={{ xs: 1, sm: withPhone ? 3 : 2 }}
            style={{ padding: '12px 16px 0' }}
            items={[
              {
                key: 'name',
                label: 'Нэр',
                children: val(group?.name || '-'),
              },
              ...(withPhone
                ? [{ key: 'phone', label: 'Утас', children: val(group?.phoneNumber || '-') }]
                : []),
              {
                key: 'address',
                label: 'Дэлгэрэнгүй',
                children: val(group?.addressName || '-'),
              },
            ]}
          />
          <Divider style={{ margin: '12px 0 0' }} />
          <ProductTable products={group.products} detail={detail} />
        </Card>
      ));

  return (
    <Space direction="vertical" size={16} style={{ width: '100%', padding: 16 }}>
      <Card
        size="middle"
        title={
          <Space size={8} wrap>
            <Title level={5} style={{ margin: 0 }}>
              {val(detail?.code)}
            </Title>
          </Space>
        }
        extra={
          <Space>
            {detail?.orderStatus === 'created' && (
              <Popconfirm
                placement="bottomRight"
                title={rejectedText}
                onConfirm={onReject}
                okText="Тийм"
                cancelText="Үгүй"
              >
                <Button danger>Цуцлах</Button>
              </Popconfirm>
            )}
            <Dropdown overlay={more} trigger={['click']} placement="bottomRight">
              <Button icon={<img src={imgMore} alt="Бусад үйлдэл" height={15} />} />
            </Dropdown>
          </Space>
        }
      >
        <Descriptions
          {...descriptionProps}
          column={{ xs: 1, sm: 3 }}
          items={[
            {
              key: 'code',
              label: 'Захиалгын дугаар',
              children: val(detail?.code || '-'),
            },
            {
              key: 'date',
              label: 'Үүссэн огноо',
              children: val(detail?.orderStatusDate ? getDateTime(detail.orderStatusDate) : null),
            },
            {
              key: 'status',
              label: 'Төлөв',
              children: (
                <Space size={4}>
                  <DeliveryStatusBadge status={detail?.orderStatus} label={statusText} />
                </Space>
              ),
            },
          ]}
        />
      </Card>

      {renderProductGroups(detail?.warehouseOrders, 'Агуулахаас гарах барааны жагсаалт')}
      {renderProductGroups(detail?.branchOrders, 'Салбараас татах барааны жагсаалт', true)}

      <Row gutter={[16, 16]} align="top">
        <Col xs={24} xl={12}>
          <Space direction="vertical" size={16} style={{ width: '100%' }}>
            <Card
              title={
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <AiOutlineInfoCircle style={{ display: 'block', fontSize: '1em' }} />
                  Харилцагчийн мэдээлэл
                </span>
              }
              size="middle"
            >
              <Descriptions
                {...descriptionProps}
                items={[
                  { key: 'name', label: 'Нэр', children: val(detail?.customerName) },
                  { key: 'phone', label: 'Утас', children: val(detail?.customerPhone) },
                ]}
              />
            </Card>

            <Card
              title={
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <CiLocationOn style={{ display: 'block', fontSize: '1em' }} />
                  Хүлээж авах хаяг
                </span>
              }
              size="middle"
            >
              <Descriptions
                {...descriptionProps}
                items={[
                  { key: 'city', label: 'Хот/аймаг', children: val(dropoffAddress[0]?.name) },
                  { key: 'district', label: 'Дүүрэг/сум', children: val(dropoffAddress[1]?.name) },
                  { key: 'khoroo', label: 'Хороо/баг', children: val(dropoffAddress[2]?.name) },
                  {
                    key: 'detail',
                    label: 'Дэлгэрэнгүй хаяг',
                    children: val(detail?.dropoffDetail),
                  },
                  ...(Number(detail?.outOfZoneDistanceKm) > 0
                    ? [
                        {
                          key: 'outOfZone',
                          label: 'Бүсээс хэтэрсэн зай',
                          children: `${detail.outOfZoneDistanceKm} км`,
                        },
                      ]
                    : []),
                ]}
              />
            </Card>

            {detail?.contractType !== 'D' && (
              <Card
                title={
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                    <GrMapLocation style={{ display: 'block', fontSize: '1em' }} />
                    Хаанаас авах
                  </span>
                }
                size="middle"
              >
                <Descriptions
                  {...descriptionProps}
                  items={[
                    {
                      key: 'type',
                      label: 'Авах хэлбэр',
                      children: val(detail?.meta?.deliveryType?.detail?.[detail?.requestType]),
                    },
                    {
                      // 1-р шатанд сонгосон салбар/агуулахын код
                      key: 'position',
                      label: 'Салбар / Агуулах',
                      children: val(detail?.pickupAddressCode),
                    },
                    {
                      key: 'from',
                      label: 'Хаанаас',
                      children: val(pickupAddressText || null),
                    },
                  ]}
                />
              </Card>
            )}
          </Space>
        </Col>

        <Col xs={24} xl={12}>
          <Space direction="vertical" size={16} style={{ width: '100%' }}>
            <Card
              title={
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <MdDateRange style={{ display: 'block', fontSize: '1em' }} />
                  Хүлээж авах огноо
                </span>
              }
              size="middle"
            >
              <Descriptions
                {...descriptionProps}
                items={[
                  {
                    key: 'date',
                    label: 'Авах огноо',
                    children: val(
                      detail?.dropoffDate ? moment(detail.dropoffDate).format('YYYY/MM/DD') : null
                    ),
                  },
                  { key: 'time', label: 'Авах цаг', children: val(dropoffTime) },
                ]}
              />
            </Card>

            <Card
              title={
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <IoWarningOutline style={{ display: 'block', fontSize: '1em' }} />
                  Анхаарах шаардлагатай зүйлс
                </span>
              }
              size="middle"
            >
              <Descriptions
                {...descriptionProps}
                column={2}
                items={[
                  ...(attentionNotes.length > 0
                    ? [{ key: 'notes', label: 'Анхаарах', children: attentionNotes.join(', ') }]
                    : []),
                  {
                    key: 'description',
                    label: 'Нэмэлт',
                    children: val(detail?.orderDescription),
                  },
                ]}
              />
            </Card>

            <Card
              title={
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                  <IoDocumentTextOutline style={{ display: 'block', fontSize: '1em' }} />
                  Баримт
                </span>
              }
              size="middle"
            >
              {detail?.images?.length > 0 ? (
                <Image.PreviewGroup
                  preview={{
                    visible,
                    onVisibleChange: (vis) => setVisible(vis),
                  }}
                >
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, padding: 4 }}>
                    {detail.images.map((img, i) => (
                      <Image
                        key={i}
                        width={72}
                        height={72}
                        src={img}
                        wrapperStyle={{
                          borderRadius: 6,
                          overflow: 'hidden',
                          boxShadow:
                            '0 1px 2px rgba(16, 24, 40, 0.06), 0 4px 8px rgba(16, 24, 40, 0.16)',
                        }}
                        style={{ objectFit: 'cover', display: 'block' }}
                        onClick={() => setVisible(true)}
                        preview={{ visible: false }}
                      />
                    ))}
                  </div>
                </Image.PreviewGroup>
              ) : (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Өгөгдөл байхгүй байна."
                  style={{ margin: 0 }}
                />
              )}
            </Card>
            {detail?.orderOtp && (
              <Card title="Хүлээлгэн өгөх код" size="middle">
                <Text strong copyable style={{ fontSize: 16, letterSpacing: 2 }}>
                  {detail.orderOtp}
                </Text>
              </Card>
            )}
          </Space>
        </Col>
      </Row>

      <Modal
        open={isSlipVisible}
        onCancel={closeDeliverySlip}
        onOk={onPrint}
        closable={false}
        style={{ minWidth: '842px', padding: 0 }}
        className="print_del_slip_modal"
        okText="Хэвлэх"
      >
        <div ref={slipRef}>
          <DeliverySlip data={detail} />
        </div>
      </Modal>
    </Space>
  );
};

export default Detail;
